import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=24dcc871&scoped=true&"
import script from "./cascader.vue?vue&type=script&lang=js&"
export * from "./cascader.vue?vue&type=script&lang=js&"
import style0 from "./cascader.vue?vue&type=style&index=0&id=24dcc871&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dcc871",
  null
  
)

export default component.exports